import React from 'react';
import Header from '../../Components/Header/Header';
import HeroText from '../../Components/HeroText/HeroText';
import Footer from '../../Components/Footer/Footer';
import CareerContact from '../../Components/CareerContact/CareerContact';
import './InternshipPage.scss';

const InternshipPage = () => {
  return (
    <div>
      <Header />
      <HeroText
        title={'Internship Registration Form'}
        content={
          'Ready to dive into the world of web development? Join our 1-month online internship and master React & JavaScript through hands-on projects, 1:1 mentorship, and daily support. Top performers could even land a paid internship or job offer! Apply now limited seats available!'
        }
      />
      <div className="container">
        <div className="internship-page-content">
          <iframe
            title="Google Form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSemIpWgMFIqDcXv7STWi-BcxhwrNjroHBaMu1G4slsh6UqBew/viewform?embedded=true"
            width="100%"
            height="100%"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            allowFullScreen>
            Loading…
          </iframe>
        </div>
      </div>
      <CareerContact />
      <Footer />
    </div>
  );
};

export default InternshipPage;
